export default "__VITE_ASSET__CKhRipVu__"